














import Vue from 'vue'
import { AmataModal } from '@/components/AmataModal'
import { removeElement } from '@/utils/helpers'

export default Vue.extend({
  name: 'AmataAlert',
  extends: AmataModal,
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    cancelText: {
      type: String,
      default: 'キャンセル'
    },
    hasInput: {
      type: Boolean,
      default: false
    },
    inputAttrs: {
      type: Object,
      default: () => ({})
    },
    onConfirm: {
      type: Function,
      default: null
    },
    focusOn: {
      type: String,
      default: 'confirm'
    }
  },
  data() {
    const prompt = this.hasInput ? this.inputAttrs.value || '' : ''
    return {
      prompt,
      isActive: true,
      validationMessage: ''
    }
  },
  computed: {
    // TODO: なぜか props が型推論できない
    showCancel(this: any) {
      return this.cancelOptions.indexOf('button') >= 0
    }
  },
  beforeMount() {
    document.body.appendChild(this.$el)
  },
  async mounted() {
    this.isActive = true

    if (typeof this.inputAttrs.required === 'undefined') {
      this.$set(this.inputAttrs, 'required', true)
    }

    // await this.$nextTick()
    // if (this.hasInput) {
    //   this.$refs.input['focus']()
    // } else if (this.focusOn === 'cancen' && this.showCancel) {
    //   this.$refs.cancelButton['focus']()
    // } else {
    //   this.$refs.confirmButton['focus']()
    // }
  },
  methods: {
    onClickedOK() {
      this.confirm()
      this.close()
    },

    async confirm() {
      // if (this.$refs.input !== 'undefined' && !this.$refs.input['checkValidity']()) {
      //   this.validationMessage = this.$refs.input['validationMessage']
      //   await this.$nextTick()
      //   this.$refs.input['select']()
      // }

      if (this.onConfirm) {
        this.onConfirm(this.prompt)
      }
      this.close()
    },

    close() {
      this.isActive = false
      setTimeout(() => {
        this.$destroy()
        removeElement(this.$el)
      }, 150)
    }
  }
})
